import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Location } from '@reach/router'
import Student from './Student'
import {
    coursPreparatoiresTocFilter,
    horaireDesCoursTocFilter,
    inscriptionUnitesPreparatoiresTocFilter,
    isGenieTerritorial,
    isHeg,
    isPt,
    journeeAccueilTocFilter,
    verificationNiveauMathTocFilter,
} from './lib/utils'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: '#fff',
        borderTop: '1px solid #e0e0e0',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.08)',
        zIndex: 1200,
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
    },
    left: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minWidth: 0,
    },
    stepCount: {
        fontSize: 12,
        color: '#20A78F',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    stepName: {
        fontSize: 14,
        color: '#333',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginTop: 2,
    },
    menuButton: {
        display: 'flex',
        alignItems: 'center',
        color: '#20A78F',
        fontSize: 13,
        fontWeight: 500,
        marginLeft: 12,
        flexShrink: 0,
    },
    icon: {
        fontSize: 20,
        marginLeft: 2,
    },
}))

const seesAhesMenu = ({ ahesRequired, visaRequired, visaAcquired }) =>
    ahesRequired && (!visaRequired || visaAcquired)

const isHegAndPt = (student) => isHeg(student) && isPt(student)

const cantSeeVerificationNiveauxLangues = (student) => isGenieTerritorial(student)

function getTocSteps(student) {
    const steps = [
        { path: '/2026/accueil', title: 'Accueil' },
        { path: '/2026/comptes-acces', title: "Comptes d'acces" },
    ]

    if (seesAhesMenu(student)) {
        steps.push({ path: '/2026/financement-de-vos-etudes', title: 'Financement de vos etudes' })
    }
    if (!cantSeeVerificationNiveauxLangues(student)) {
        steps.push({ path: '/2026/verification-niveaux-langues', title: 'Verification des niveaux de langues' })
    }
    steps.push({ path: '/2026/code-de-savoir-vivre', title: 'Code de savoir-vivre' })
    steps.push({ path: '/2026/assurance-maladie-et-accident', title: 'Assurance maladie et accident' })
    if (isHegAndPt(student)) {
        steps.push({ path: '/2026/cours-marketing', title: 'Cours de marketing' })
    }

    steps.push({ path: '/2026/preparation-a-l-immatriculation', title: 'Votre immatriculation' })
    if (verificationNiveauMathTocFilter(student)) {
        steps.push({ path: '/2026/evaluation-niveau-math', title: 'Auto-contrôle des prérequis en mathématiques' })
    }
    if (coursPreparatoiresTocFilter(student)) {
        steps.push({ path: '/2026/cours-preparatoires', title: 'Cours preparatoires' })
    }
    if (inscriptionUnitesPreparatoiresTocFilter(student)) {
        steps.push({ path: '/2026/inscription-unites-preparatoires', title: 'Unites preparatoires' })
    }
    steps.push({ path: '/2026/demande-equivalence', title: "Demande d'equivalence" })
    steps.push({ path: '/2026/ordinateur-portable', title: 'Ordinateur portable' })

    if (journeeAccueilTocFilter(student)) {
        steps.push({ path: '/2026/journee-d-accueil', title: "Journee d'accueil" })
    }
    steps.push({ path: '/2026/rentree-et-calendrier-academique', title: 'Rentree et calendrier academique' })
    steps.push({ path: '/2026/attestation-d-etudes', title: "Attestation d'etudes" })

    steps.push({ path: '/2026/taxe-annuelle-etudes', title: "Taxe annuelle d'etudes" })
    steps.push({ path: '/2026/votre-carte-etudiant-e', title: "Votre carte d'etudiant-e" })
    steps.push({ path: '/2026/guide-de-l-etudiant-e', title: "Guide de l'etudiant-e" })
    if (horaireDesCoursTocFilter(student)) {
        steps.push({ path: '/2026/horaire-des-cours', title: 'Horaire des cours' })
    }
    steps.push({ path: '/2026/problemes-sante-specifiques', title: 'Problemes de sante specifiques' })
    steps.push({ path: '/2026/situation-de-handicap-ou-maladie', title: 'Situation de handicap ou maladie' })
    steps.push({ path: '/2026/studios-appartements-chambres', title: 'Studios / Appartements / Chambres' })
    steps.push({ path: '/2026/mobilite', title: 'Mobilite - Venir a la HEIG-VD' })
    steps.push({ path: '/2026/renonciation', title: 'Renonciation' })

    return steps
}

export default ({ onOpenMenu }) => {
    const styles = useStyles()
    const { student } = Student.useContainer()
    const steps = getTocSteps(student)

    return (
        <Location>
            {({ location }) => {
                const currentIndex = steps.findIndex((s) => s.path === location.pathname)
                const total = steps.length
                const current = currentIndex >= 0 ? currentIndex + 1 : null
                const title = currentIndex >= 0 ? steps[currentIndex].title : null

                return (
                    <div className={styles.root} onClick={onOpenMenu}>
                        <div className={styles.left}>
                            <span className={styles.stepCount}>
                                {current
                                    ? `Etape ${current} / ${total}`
                                    : `${total} etapes`}
                            </span>
                            {title && (
                                <span className={styles.stepName}>{title}</span>
                            )}
                        </div>
                        <div className={styles.menuButton}>
                            Voir tout
                            <KeyboardArrowUpIcon className={styles.icon} />
                        </div>
                    </div>
                )
            }}
        </Location>
    )
}
